<div class="prefix-groups-summary">
  <div *ngIf="prefixGroup?.length !== 1" class="arm-summary">{{prefixGroup?.length || 0}} Items selected</div>
  <div *ngIf="prefixGroup?.length === 1" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="prefixGroup[0].name" class="arm-summary-value" fxFlex>{{prefixGroup[0].name}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Type:</span>
      <span class="arm-summary-value" fxFlex>{{prefixGroup[0].type}}</span>
    </div>

    <div class="arm-summary-item prefix-values" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Values:</span>
      <span [title]="prefixGroup[0].values" class="arm-summary-value prefix-values"
            fxFlex>{{prefixGroup[0].values.join(", ")}}</span>
    </div>

    <ac-line-separator separatorId="prefix_policy_separator" title="Policy studio"></ac-line-separator>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Used in policy studio:</span>
      <span class="arm-summary-value prefix-values" [title]="policyStudio">{{policyStudio}}</span>
    </div>

    <ac-line-separator separatorId="prefix_rules_separator" title="Routing rule"></ac-line-separator>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Used in routing rules:</span>
      <span *ngIf="rules === 'None'" class="arm-summary-value" fxFlex>{{rules}}</span>
      <div *ngIf="rules !== 'None'" class="prefix-details-tree">
        <info-tree [keyValueMode]=false [json]="rules"></info-tree>
      </div>
    </div>
  </div>
</div>
